import React, { lazy } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { getCurrentUserRole } from './services/common.services';
import Colors from '../src/utils/styles/colors';

const CollectionsLayout = lazy(() => import('./components/layouts/CollectionsLayout'));
const ClientLayout = lazy(() => import('./components/layouts/ClientLayout'));
const UserLayout = lazy(() => import('./components/layouts/UserLayout'));
const SignIn = lazy(() => import('./views/Autnentication/SignIn'));
const CreateAccount = lazy(() => import('./views/Autnentication/CreateAccount'));
const ForgotPassword = lazy(() => import('./views/Autnentication/ForgotPassword'));
const ResetPassword = lazy(() => import('./views/Autnentication/ResetPassword'));
const Logout = lazy(() => import('./views/Autnentication/Logout'));
const Auth = lazy(() => import('./views/Autnentication/Auth'));
const ValidateInvite = lazy(() => import('./views/Autnentication/ValidateInvite'));



export default function TheameComponent() {
    const CustomTheme = createTheme({
        palette: {
            primary: {
                main: Colors.PRIMARY_GREEN,
                light: Colors.PRIMARY_GREEN
            },
            secondary: {
                main: Colors.GREY,
                light: Colors.GREY
            }
        }
    })
    return (
        <ThemeProvider theme={CustomTheme}>
            <BrowserRouter>
                <Switch>
                    <Route path="/collections" render={props =>
                        (getCurrentUserRole() === 'AgentAdmin' || getCurrentUserRole() === 'AgentUser') ?
                            <CollectionsLayout {...props} />
                            :
                            getCurrentUserRole() === 'SuperAdmin' || getCurrentUserRole() === 'DC-SuperAdmin' ?
                                <UserLayout {...props} />
                                :
                                <ClientLayout {...props}
                                />
                    } />
                    <Route path="/signin" render={(props) => getCurrentUserRole() ? <Redirect to="/" /> : <SignIn {...props} />} />
                    <Route path="/create-account" render={(props) => <CreateAccount {...props} />} />
                    <Route path="/forgot-password" render={(props) => <ForgotPassword {...props} />} />
                    <Route path="/reset-password" render={(props) => <ResetPassword {...props} />} />
                    <Route path="/validate-invite" render={(props) => <ValidateInvite {...props} />} />
                    <Route path="/logout" render={(props) => getCurrentUserRole() ? <Redirect to="/" /> : <Logout {...props} />} />
                    <Route path="/auth" render={(props) => <Auth {...props} />} />
                    <Redirect from="/*" to="/collections" />
                </Switch>
            </BrowserRouter>
        </ThemeProvider>
    )
}
